import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL + "/api/SalaryAdvType";

export function getSalaryAdvList(addId) {
  return http.post(`${apiEndpoint}/GetDropDown/?addId=${addId}`);
}
